import React, { useState } from 'react';
import clsx from 'clsx';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';
import { ListDashesIcon } from '../../icons/listDashesIcon';

export const PageList = ({
  isOpen,
  sizeList,
  setPopover,
  defaultValue,
  isDarkTheme = false,
  handlePerPageDataFetch,
}) => {
  const [pageCount, setPerPage] = useState(defaultValue);
  return (
    <Popover
      open={isOpen}
      onOpenChange={(open) => {
        setPopover(open);
      }}
    >
      <PopoverTrigger
        className={clsx(
          'rounded-full border text-[#282828] px-6 py-3 flex gap-3 items-center max-lg:hidden'
        )}
      >
        <ListDashesIcon color={isDarkTheme ? 'white' : 'black'} />
        <span
          className={
            isDarkTheme ? 'text-white text-label' : 'text-black text-label'
          }
        >
          Αποτελέσματα ανά σελίδα
        </span>
        <span
          className={
            isDarkTheme ? 'text-white text-body' : 'text-black text-body'
          }
        >
          {pageCount === -1 ? 'Όλα' : pageCount}
        </span>
      </PopoverTrigger>
      <PopoverContent className="flex flex-col gap-6 w-[250px]">
        {sizeList.map((option) => (
          <div
            key={option.name}
            onClick={() => {
              setPerPage(option.value);
              handlePerPageDataFetch && handlePerPageDataFetch(option.value);
            }}
            className={`${
              pageCount === option.value
                ? 'bg-black text-secondary'
                : 'border-[#A5A5A5] text-[#282828]'
            } justify-center rounded-full border  px-6 py-3 text-label flex gap-3 items-center cursor-pointer`}
          >
            {option.name}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export const PageListMobile = ({
  isOpen,
  sizeList,
  setPopover,
  defaultValue,
  isDarkTheme = false,
  handlePerPageDataFetch,
}) => {
  const [pageCount, setPerPage] = useState(defaultValue);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setPopover(open)}>
      <DialogTrigger>
        <ListDashesIcon
          color="white"
          className={'bg-primary rounded-full p-1 h-8 w-8 lg:hidden'}
        />
      </DialogTrigger>
      <DialogContent className="px-6 pt-3 pb-10 grid">
        <h3>Αποτελέσματα ανά σελίδα</h3>
        {sizeList.map((option) => (
          <div
            key={option.name}
            onClick={() => {
              setPerPage(option.value);
              handlePerPageDataFetch && handlePerPageDataFetch(option.value);
            }}
            className={`${
              pageCount === option.value
                ? 'bg-black text-secondary'
                : 'border-fadedgrey text-midgrey'
            } justify-between rounded-full border  px-6 py-3 text-label flex gap-3 items-center`}
          >
            {option.name}
            <ListDashesIcon
              className={`w-5 h-5`}
              color={`${pageCount === option.value ? 'white' : 'black'}`}
            />
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};
